import { compact, without } from 'lodash-es'

const lockAskInviteePosition = (sortedLocations) => {
  const askInvitee = sortedLocations.find((location) => (
    location.kind === 'ask_invitee'
  ))
  if (!askInvitee) {
    return sortedLocations
  }

  return compact([
    ...without(sortedLocations, askInvitee),
    askInvitee,
  ])
}

export const filterActiveLocations = (locations) => locations.filter((location) => !location._destroy)

export const sortLocationsByPosition = (locations) => locations.sort((a, b) => a.position - b.position)

export const normalizeLocationConfigurationsOrdering = (locations) => {
  const activeLocations = filterActiveLocations(locations)
  const sortedLocations = activeLocations.sort((currValue, nextValue) => currValue.position - nextValue.position)
  const lockedAskInviteeLocations = lockAskInviteePosition(sortedLocations)

  const repositionedLocations = lockedAskInviteeLocations.map((location, index) => ({
    ...location,
    position: index
  }))

  const destroyedLocations = locations.filter((location) => location._destroy)

  return [...repositionedLocations, ...destroyedLocations]
}
